/**
 * TC Instant Search JS - v5.7
 * Shopify Predictive Search API + Full Search Fallback
 * Değişiklikler v5.7:
 *   - Kategoriler > Kadın 404 veriyordu (kadin-spor-urunleri koleksiyonu yok);
 *     header menüsündeki Kadın koleksiyonuna (kadin-1) bağlandı.
 * Değişiklikler v5.6 (ürün koduyla arama boş dönüyordu):
 *   - 3. adım _codeSearch(): predictive ve /search boş dönerse, sorgu ürün koduna
 *     benziyorsa kodu 10/8/6 karaktere kısaltıp arar, adayları SKU/barkodda tam
 *     kodla süzer (q=NF0A8JAY2MB1: önce 0, şimdi doğru ürün). Ayrıntı fonksiyonda.
 *   - Bu yolla bulunan sonuçlarda "Tümünü gör" ve Enter kısaltılmış koda gidiyor.
 * Değişiklikler v5.5 (arama boş dönüyordu):
 *   - unavailable_products=hide → last + istemci tarafı `available` süzgeci.
 *     Shopify arama indeksi stoktaki ürünleri "tükendi" sanınca hide her şeyi
 *     gizliyordu (2026-10-09: "skechers" 0 sonuç). Ayrıntı _search() içinde.
 *   - "Tümünü gör", Enter ve önerilen aramalar /search'e unavailable_products=last
 *     ile gidiyor (parametresiz hali mağaza varsayılanına düşüp 0 sonuç veriyordu).
 * Değişiklikler v5.4 (layout fix):
 *   - Sol panel (Kategoriler) 2K/4K ekranlarda eziliyordu. Sebep: box-sizing:border-box
 *     olan panele width:240px verilip padding olarak 5vw kullanılmıştı; 2560px'de
 *     padding 76.8+128=204.8px olup içerik genişliği 19px'e, 3840px'de 0'a düşüyordu.
 *     Artık boşluklar clamp'li CSS değişkeni (--tc-pad) ve sol panelin flex-basis'i
 *     içerik genişliği + padding olarak hesaplanıyor.
 *   - Ürün grid'i repeat(5,1fr) idi; 2560px'de kolon 397px, kart 496px oluyordu ama
 *     sağ panelin yüksekliği 439px + overflow:hidden → kartlar alttan kesiliyordu.
 *     Grid'e max-width geldi, sağ panel dikeyde kaydırılabilir oldu.
 *   - Mobilde arama sonuçları artık kategorilerin ÜSTÜNDE (order ile).
 * Değişiklikler v5.3:
 *   - SKU/Barcode/Ürün kodu ile arama desteği (fullSearch fallback)
 *   - Predictive Search sonuç bulamazsa otomatik olarak full search devreye girer
 *   - /products/handle.js ile ürün detayları paralel çekilir
 */
window.TCSearch = (function () {
  'use strict';

  const DEBOUNCE_MS  = 250;
  const MIN_CHARS    = 2;
  const MAX_PRODUCTS = 10;
  const PAGE_SIZE    = 5;
  const SEARCH_URL   = window.routes?.predictive_search_url || '/search/suggest';

  /* Arama SONUÇ sayfasına giden tüm linklerin ortak parametreleri.
     unavailable_products=last ŞART: parametresiz /search mağaza varsayılanına
     (gizle) düşüyor ve arama indeksi bayatladığında "0 sonuç" veriyor. */
  const FULL_SEARCH_PARAMS = '&type=product&options[unavailable_products]=last';
  const _fullSearchHref = (q) => `/search?q=${encodeURIComponent(q)}${FULL_SEARCH_PARAMS}`;

  const FEATURED_COLLECTION = 'frontpage';

  const FEATURED_BRANDS = [
    { label: 'Skechers',      url: '/collections/skechers'      },
    { label: 'Salomon',       url: '/collections/salomon'       },
    { label: 'Merrell',       url: '/collections/merrell'       },
    { label: 'Jack Wolfskin', url: '/collections/jack-wolfskin' },
    { label: 'New Balance',   url: '/collections/new-balance'   },
  ];


  const QUICK_CATEGORIES = [
    { label: 'Kadın',           url: '/collections/kadin-1'                },
    { label: 'Erkek',           url: '/collections/erkek-spor-urunleri'    },
    { label: 'Erkek Ayakkabı',  url: '/collections/tum-erkek-ayakkabilari' },
    { label: 'Kadın Ayakkabı',  url: '/collections/tum-kadin-ayakkabilari' },
    { label: 'Koşu Ayakkabısı', url: '/collections/kosu-ayakkabilari'      },
    { label: 'Outdoor',         url: '/collections/outdoor'                },
    { label: 'İndirim',         url: '/collections/i̇ndirimli-urunler'      },
  ];

  let _debounceTimer    = null;
  let _currentQuery     = '';
  let _abortController  = null;
  let _sliderPage       = 0;
  let _sliderProducts   = [];
  let _sliderQuery      = '';
  let _sliderLinkQuery  = '';  // "Tümünü gör"/Enter'ın gideceği sorgu (ürün kodunda kısaltılmış hali)
  let _featuredProducts = null;

  const _getEl = (id) => document.getElementById(id);

  const S = {
    /* Boşluklar CSS değişkeni üzerinden — değerler _injectStyles() içinde tanımlı.
       5vw gibi sınırsız viewport birimi KULLANMA: sol panelin genişliği sabit px
       olduğu için geniş ekranda padding genişliği yiyip içeriği eziyordu. */
    padX:       'var(--tc-pad)',        // panelin dış (sol/sağ kenar) boşluğu
    padXInner:  'var(--tc-pad-inner)',  // sol ve sağ panel arasındaki iç boşluk
    sidebarW:   'var(--tc-sidebar)',    // sol panelin İÇERİK genişliği (padding hariç)
    imgH:       '160px',
    red:        '#e60000',
    border:     '#f0f0f0',
    sectionTitle: 'font-size:10px;font-weight:700;text-transform:uppercase;color:#aaa;letter-spacing:0.8px;margin:0 0 14px',
    catLink: 'display:block;padding:8px 0;font-size:13px;color:#333;text-decoration:none;line-height:1.4;border-bottom:1px solid #f5f5f5',
  };

  /* Ürün grid'i: kolon sayısı PAGE_SIZE ile eşleşmek zorunda (5).
     max-width olmadan 2560px'de kolon 397px'e çıkıyor, aspect-ratio:1/1 kart
     496px yükseliyor ve 520px'lik panelin içinde kesiliyordu. 1180px sınırı
     kolonu ~220px'de tutar → kart ~310px, panele rahat sığar.
     DİKKAT: mobil medya sorgusu `[style*="repeat(5"]` ile eşleşiyor, bu metni bozma. */
  const GRID = 'display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:16px;max-width:1180px';

  // ─── PANEL HTML ──────────────────────────────────────────
  function _buildPanelHTML() {
    const brandsHTML = FEATURED_BRANDS.map(b =>
      `<a href="${b.url}" style="color:#111;text-decoration:none;font-size:13px;font-weight:500;
        padding:5px 16px;border:1px solid #ddd;border-radius:20px;white-space:nowrap;
        transition:all 0.15s;background:#fff"
        onmouseover="this.style.background='#111';this.style.color='#fff'"
        onmouseout="this.style.background='#fff';this.style.color='#111'"
      >${_escape(b.label)}</a>`
    ).join('');

    return `
      <div style="display:flex;align-items:center;gap:20px;
        padding:14px ${S.padX};
        border-bottom:1px solid ${S.border};
        background:#fff;flex-shrink:0">
        <div style="position:relative;display:flex;align-items:center;flex:0 0 340px">
          <svg style="position:absolute;left:14px;color:#aaa;pointer-events:none"
               width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <input type="search" id="tc-search-panel-input"
                 style="width:100%;padding:10px 14px 10px 40px;border:1.5px solid #e8e8e8;
                   border-radius:24px;font-size:14px;outline:none;background:#fafafa;
                   transition:border-color 0.2s"
                 placeholder="Ürün, marka veya kategori ara..."
                 autocomplete="off" autocorrect="off" spellcheck="false"
                 onfocus="this.style.borderColor='#111';this.style.background='#fff'"
                 onblur="this.style.borderColor='#e8e8e8';this.style.background='#fafafa'">
        </div>
        <div style="display:flex;align-items:center;gap:8px;flex:1;min-width:0;overflow:hidden;flex-wrap:wrap">
          <span style="font-size:11px;color:#bbb;white-space:nowrap;font-weight:700;
            text-transform:uppercase;letter-spacing:0.6px;margin-right:4px">
            Öne Çıkan Markalar
          </span>
          ${brandsHTML}
        </div>
        <button id="tc-panel-close-btn"
                style="background:none;border:none;cursor:pointer;font-size:11px;font-weight:700;
                  color:${S.red};white-space:nowrap;padding:6px 0;letter-spacing:0.8px;
                  text-transform:uppercase;flex-shrink:0">
          ✕ KAPAT
        </button>
      </div>
      <div style="display:flex;flex:1;overflow:hidden;min-height:0">
        <div id="tc-search-left"
             style="box-sizing:border-box;
               flex:0 0 calc(${S.sidebarW} + ${S.padX} + ${S.padXInner});
               border-right:1px solid ${S.border};
               padding:24px ${S.padXInner} 24px ${S.padX};
               overflow-y:auto;background:#fff">
          ${_buildLeftPanel('')}
        </div>
        <div id="tc-search-right"
             style="flex:1 1 auto;min-width:0;
               padding:24px ${S.padX} 24px ${S.padXInner};
               overflow-x:hidden;overflow-y:auto;position:relative;background:#fff">
          <div id="tc-search-loading"
               style="display:none;align-items:center;gap:12px;color:#999;padding:30px 0">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                 style="animation:tc-spin 0.8s linear infinite">
              <circle cx="12" cy="12" r="10" stroke-opacity="0.2"/>
              <path d="M12 2a10 10 0 0 1 10 10"/>
            </svg>
            <span style="font-size:13px">Aranıyor...</span>
          </div>
          <div id="tc-search-results-inner" style="display:none"></div>
          <div id="tc-search-featured" style="display:none"></div>
          <div id="tc-search-empty"
               style="display:none;flex-direction:column;align-items:center;
                 justify-content:center;padding:50px;gap:12px">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ddd" stroke-width="1.5">
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <p style="margin:0;color:#aaa;font-size:14px;font-weight:500">Sonuç bulunamadı.</p>
            <span style="font-size:12px;color:#ccc">Farklı bir kelime deneyin</span>
          </div>
        </div>
      </div>`;
  }

  // ─── SOL PANEL ───────────────────────────────────────────
  function _buildLeftPanel(query) {
    const catsHTML = QUICK_CATEGORIES.map(c =>
      `<a href="${c.url}" style="${S.catLink}"
         onmouseover="this.style.color='${S.red}';this.style.paddingLeft='6px'"
         onmouseout="this.style.color='#333';this.style.paddingLeft='0'"
       >${_escape(c.label)}</a>`
    ).join('');

    let suggestHTML = '';
    if (query.length >= MIN_CHARS) {
      const suggestions = [
        `${query} Erkek`,
        `${query} Kadın`,
        `${query} Erkek Ayakkabı`,
        `${query} Kadın Ayakkabı`,
        `${query} Unisex`,
      ];
      suggestHTML = `
        <div style="margin-top:20px;padding-top:20px;border-top:1px solid ${S.border}">
          <div style="${S.sectionTitle}">Önerilen Aramalar</div>
          ${suggestions.map(s => `
            <a href="${_fullSearchHref(s)}"
               style="${S.catLink};display:flex;align-items:center;gap:8px;color:#555"
               onmouseover="this.style.color='${S.red}';this.style.paddingLeft='6px'"
               onmouseout="this.style.color='#555';this.style.paddingLeft='0'"
            >
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#bbb" stroke-width="2" style="flex-shrink:0">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
              ${_escape(s)}
            </a>`).join('')}
        </div>`;
    }

    return `
      <div>
        <div style="${S.sectionTitle}">Kategoriler</div>
        ${catsHTML}
      </div>
      ${suggestHTML}`;
  }

  // ─── ÜRÜN KARTI HTML ─────────────────────────────────────
  function _productCardHTML(product, query, isSearchResult) {
    const price        = parseFloat(product.price || 0);
    const comparePrice = parseFloat((product.compare_at_price_max || product.compare_at_price) || 0);
    const onSale       = comparePrice > 0 && comparePrice > price;
    const discount     = onSale ? Math.round((comparePrice - price) / comparePrice * 100) : 0;

    const imgSrc = product.featured_image?.url
      ? `${product.featured_image.url}&width=400`
      : (product.featured_image?.src
        ? product.featured_image.src.split('?')[0] + '?width=400'
        : null);

    const url = product.url || `/products/${product.handle}`;
    const title = isSearchResult ? _highlight(product.title, query) : _escape(product.title);

    let html = `
      <a href="${url}" style="text-decoration:none;color:inherit;display:flex;flex-direction:column;
        background:#fff;border-radius:8px;overflow:hidden;min-width:0;
        transition:box-shadow 0.2s,transform 0.2s"
        onmouseover="this.style.boxShadow='0 4px 20px rgba(0,0,0,0.10)';this.style.transform='translateY(-2px)'"
        onmouseout="this.style.boxShadow='none';this.style.transform='none'"
      >`;

    html += `<div style="position:relative;background:#f7f7f7;border-radius:8px;
      overflow:hidden;aspect-ratio:1/1;display:flex;align-items:center;justify-content:center">`;

    if (imgSrc) {
      html += `<img src="${imgSrc}" alt="${_escape(product.title)}" loading="lazy"
        style="width:100%;height:100%;object-fit:contain;padding:12px">`;
    } else {
      html += `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ddd" stroke-width="1">
        <rect x="3" y="3" width="18" height="18" rx="2"/>
        <circle cx="8.5" cy="8.5" r="1.5"/>
        <polyline points="21 15 16 10 5 21"/>
      </svg>`;
    }

    if (onSale) {
      html += `<span style="position:absolute;top:8px;left:8px;background:${S.red};color:#fff;
        font-size:10px;font-weight:700;padding:2px 7px;border-radius:4px">%${discount}</span>`;
    }

    html += `</div>`;

    html += `<div style="padding:10px 4px 6px">`;
    html += `<div style="font-size:10px;font-weight:800;color:${S.red};text-transform:uppercase;
      letter-spacing:0.4px;margin-bottom:4px">${_escape(product.vendor || '')}</div>`;
    html += `<div style="font-size:12px;color:#1a1a1a;line-height:1.4;margin-bottom:6px;
      display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;
      min-height:34px">${title}</div>`;

    html += `<div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap">`;
    if (onSale) {
      html += `<span style="font-size:13px;font-weight:800;color:${S.red}">${_formatMoney(price)}</span>`;
      html += `<span style="font-size:11px;color:#bbb;text-decoration:line-through">${_formatMoney(comparePrice)}</span>`;
    } else {
      html += `<span style="font-size:13px;font-weight:700;color:#111">${_formatMoney(price)}</span>`;
    }
    html += `</div>`;

    /* Kampanya rozetleri.
       Instant search sonuçları #tc-products-data'dan gelmediği için product.promos
       taşımaz; TCPromo.keysFor() hedef ÜYELİĞİNE bakar (kural işletmez — tarih/
       aktiflik/gösterim filtreleri Liquid'de #tc-promos-data'ya girerken uygulandı).
       Ayrıntı: assets/tc-promo.js başındaki not + docs/kampanya-sistemi.md */
    if (typeof TCPromo !== 'undefined') {
      const promoHTML = TCPromo.renderForSearch(product);
      if (promoHTML) html += promoHTML;
    }

    html += `</div></a>`;
    return html;
  }

  // ─── FEATURED PRODUCTS RENDER ────────────────────────────
  function _renderFeaturedProducts() {
    const container = _getEl('tc-search-featured');
    if (!container) return;

    if (!_featuredProducts || !_featuredProducts.length) {
      container.style.display = 'none';
      return;
    }

    let html = `<div style="${S.sectionTitle}">Popüler Ürünler</div>`;
    html += `<div style="${GRID}">`;
    _featuredProducts.forEach(function(p) {
      html += _productCardHTML(p, '', false);
    });
    html += `</div>`;

    container.innerHTML = html;
    container.style.display = 'block';
  }

  // ─── SEARCH RESULT RENDER ────────────────────────────────
  function _renderSliderPage() {
    const inner = _getEl('tc-search-results-inner');
    if (!inner) return;

    const products   = _sliderProducts;
    const query      = _sliderQuery;
    const totalPages = Math.ceil(products.length / PAGE_SIZE);
    const start      = _sliderPage * PAGE_SIZE;
    const pageItems  = products.slice(start, start + PAGE_SIZE);

    let html = `
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;max-width:1180px">
        <span style="${S.sectionTitle};margin:0">Arama Sonuçları</span>
        <a href="${_fullSearchHref(_sliderLinkQuery || query)}&options[prefix]=last&options[fields]=title,vendor,product_type,variants.title,variants.sku,variants.barcode"
           style="font-size:12px;color:${S.red};text-decoration:none;font-weight:600">
          Tümünü gör →
        </a>
      </div>
      <div style="position:relative;max-width:1180px">
        <div style="${GRID}">`;

    pageItems.forEach(function(p) {
      html += _productCardHTML(p, query, true);
    });

    html += `</div>`;

    if (_sliderPage > 0) {
      html += _arrowBtn('tc-slider-prev', 'left:-18px', '15 18 9 12 15 6');
    }
    if (_sliderPage < totalPages - 1) {
      html += _arrowBtn('tc-slider-next', 'right:-18px', '9 18 15 12 9 6');
    }

    html += `</div>`;
    inner.innerHTML = html;

    const next = _getEl('tc-slider-next');
    if (next) next.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      if (_sliderPage < Math.ceil(_sliderProducts.length / PAGE_SIZE) - 1) {
        _sliderPage++; _renderSliderPage(); _showState('results');
      }
    });

    const prev = _getEl('tc-slider-prev');
    if (prev) prev.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      if (_sliderPage > 0) {
        _sliderPage--; _renderSliderPage(); _showState('results');
      }
    });
  }

  function _arrowBtn(id, posStyle, points) {
    return `<button id="${id}" aria-label="Kaydır"
      style="position:absolute;${posStyle};top:50%;transform:translateY(-50%);
        width:36px;height:36px;border-radius:50%;background:#fff;
        border:1px solid #e0e0e0;box-shadow:0 2px 10px rgba(0,0,0,0.10);
        cursor:pointer;display:flex;align-items:center;justify-content:center;
        color:#333;z-index:2;transition:box-shadow 0.15s"
      onmouseover="this.style.boxShadow='0 4px 16px rgba(0,0,0,0.18)'"
      onmouseout="this.style.boxShadow='0 2px 10px rgba(0,0,0,0.10)'"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <polyline points="${points}"/>
      </svg>
    </button>`;
  }

  // ─── INIT ────────────────────────────────────────────────
  function init() {
    _injectStyles();
    if (!_getEl('tc-search-overlay')) {
      const overlay = document.createElement('div');
      overlay.id = 'tc-search-overlay';
      overlay.className = 'tc-instant-search-overlay';
      document.body.appendChild(overlay);
    }
    if (!_getEl('tc-search-panel')) {
      const panel = document.createElement('div');
      panel.id = 'tc-search-panel';
      panel.className = 'tc-search-results-panel';
      document.body.appendChild(panel);
    }
    _prefetchFeaturedProducts();
  }

  // ─── FEATURED PREFETCH ───────────────────────────────────
  async function _prefetchFeaturedProducts() {
    if (_featuredProducts !== null) return;
    try {
      const res = await fetch(`/collections/${FEATURED_COLLECTION}/products.json?limit=5&fields=id,title,vendor,handle,featured_image,price,compare_at_price`);
      if (!res.ok) throw new Error('Collection fetch failed');
      const data = await res.json();
      _featuredProducts = data.products || [];
    } catch (e) {
      _featuredProducts = [];
    }
  }

  // ─── OPEN ────────────────────────────────────────────────
  function onFocus() {
    const panel   = _getEl('tc-search-panel');
    const overlay = _getEl('tc-search-overlay');
    if (!panel || panel.classList.contains('active')) return;

    /* Kampanya kapsam kümelerini panel açılırken ısıt — kullanıcı yazmaya
       başlayana kadar hazır olur. Sekme başına tek çekim (sessionStorage). */
    if (typeof TCPromo !== 'undefined') { try { TCPromo.warm(); } catch (e) {} }

    _suppressThemePopup();
    panel.innerHTML = _buildPanelHTML();
    panel.classList.add('active');

    const hh = document.querySelector('#header-sticky, .section-header, header')?.offsetHeight || 70;
    /* max-height: kısa/yatay ekranlarda (ör. 1366x768 laptop) sabit 520px pencereyi
       aşıp panelin altını görünmez yapıyordu — viewport'a göre de sınırla. */
    panel.style.cssText = [
      'position:fixed',
      'top:' + hh + 'px',
      'left:0',
      'right:0',
      'z-index:10000',
      'background:#fff',
      'display:flex',
      'flex-direction:column',
      'max-height:min(560px, calc(100vh - ' + hh + 'px - 16px))',
      'overflow:hidden',
      'box-shadow:0 12px 50px rgba(0,0,0,0.15)',
      'border-bottom:2px solid #f0f0f0'
    ].join('!important;') + '!important';

    if (overlay) {
      overlay.style.cssText = 'position:fixed!important;inset:0!important;z-index:9998!important;background:rgba(0,0,0,0.25)!important;display:block!important;backdrop-filter:blur(2px)';
      overlay.onclick = close;
    }

    const closeBtn = _getEl('tc-panel-close-btn');
    if (closeBtn) closeBtn.addEventListener('click', close);

    const panelInput = _getEl('tc-search-panel-input');
    if (panelInput) {
      panelInput.addEventListener('input', function() { _triggerSearch(this.value); });
      panelInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && _currentQuery.length >= MIN_CHARS) {
          // Ürün kodu kısaltılarak bulunduysa tam kodla /search 0 sonuç verir —
          // kısaltılmış sorguya git (bkz. _codeSearch).
          const q = (_sliderQuery === _currentQuery && _sliderLinkQuery) || _currentQuery;
          window.location.href = _fullSearchHref(q);
        }
        if (e.key === 'Escape') close();
      });
      setTimeout(function() { panelInput.focus(); }, 60);
    }

    _renderFeaturedProducts();
    _showState('featured');
    document.addEventListener('keydown', _onEsc);
  }

  function _onEsc(e) { if (e.key === 'Escape') close(); }

  function _suppressThemePopup() {
    document.querySelectorAll(
      '.predictive-search__results-list, .predictive-search__results-groups-wrapper, #predictive-search-results'
    ).forEach(function(el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  // ─── INPUT ───────────────────────────────────────────────
  function onInput(value) {
    if (!_getEl('tc-search-panel')?.classList.contains('active')) onFocus();
  }

  function _triggerSearch(value) {
    clearTimeout(_debounceTimer);
    const left = _getEl('tc-search-left');
    if (left) left.innerHTML = _buildLeftPanel(value);

    if (value.length < MIN_CHARS) {
      _showState('featured');
      return;
    }
    _currentQuery = value;
    _debounceTimer = setTimeout(() => _search(value), DEBOUNCE_MS);
  }

  // ─── SEARCH (Predictive + Full Search Fallback) ──────────
  async function _search(query) {
    if (_abortController) _abortController.abort();
    _abortController = new AbortController();
    _showState('loading');

    try {
      // 1) Önce Predictive Search API dene (hızlı, title/brand/tag aramaları)
      const fields = 'title,vendor,product_type,variants.title,variants.sku,variants.barcode';
      const url = `${SEARCH_URL}.json?q=${encodeURIComponent(query)}`
        + `&resources[type]=product`
        + `&resources[limit]=${MAX_PRODUCTS}`
        + `&resources[options][fields]=${fields}`
        + `&resources[options][prefix]=last`
        // 'hide' KULLANMA — tükenmiş ürün aşağıda product.available ile eleniyor.
        // 'hide' kararı Shopify'ın arama İNDEKSİNDEKİ stok bilgisine bakıyor ve o
        // indeks bayatlayabiliyor: 2026-10-09'da stoktaki ürünlerin ~%99'u indekste
        // "tükendi" görünüyordu (q=skechers: hide 0, show 141 — 148 ürünün hepsi
        // stokta). Yanıttaki `available` alanı ise canlı veriden geliyor ve doğruydu.
        // 'last' + istemci tarafı süzgeç: indeks sağlamken 'hide' ile aynı sonucu
        // verir (q=boxer'daki 3 tükenmiş ürün yine gizlenir), bozukken çökmez.
        + `&resources[options][unavailable_products]=last`;

      const res = await fetch(url, { signal: _abortController.signal });
      if (!res.ok) throw new Error('Search failed');
      const data = await res.json();
      let products = (data.resources?.results?.products || [])
        .filter(function(p) { return p.available !== false; });

      // 2) Sonuç yoksa → Full Search fallback (SKU/barcode/ürün kodu destekli)
      if (!products.length) {
        products = await _fullSearch(query);
      }

      // 3) Hâlâ yoksa ve sorgu ürün koduna benziyorsa → kısaltılmış kodla ara
      let linkQuery = query;
      if (!products.length) {
        const code = await _codeSearch(query);
        products  = code.products;
        linkQuery = code.linkQuery;
      }

      if (!products.length) {
        _showState('empty');
      } else {
        _sliderProducts  = products;
        _sliderQuery     = query;
        _sliderLinkQuery = linkQuery;
        _sliderPage      = 0;
        _renderSliderPage();
        _showState('results');
      }
    } catch (e) {
      if (e.name !== 'AbortError') _showState('empty');
    }
  }

  // ─── FULL SEARCH FALLBACK (SKU/Barcode destekli) ─────────
  async function _fullSearch(query) {
    try {
      // Predictive ile aynı kural: 'hide' değil 'last' — tükenmişler aşağıda
      // ürün JSON'undaki canlı `available` alanıyla eleniyor (bkz. _search).
      var searchUrl = _fullSearchHref(query)
        + '&options[prefix]=last'
        + '&options[fields]=title,vendor,product_type,variants.title,variants.sku,variants.barcode';

      var res = await fetch(searchUrl, { signal: _abortController.signal });
      if (!res.ok) return [];
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');

      // HTML'den ürün handle'larını çıkar
      var links = doc.querySelectorAll('a[href*="/products/"][href*="_pos="]');
      var handles = [];
      var seen = {};
      for (var i = 0; i < links.length; i++) {
        var href = links[i].getAttribute('href') || '';
        var match = href.match(/\/products\/([^?#\/]+)/);
        if (match && !seen[match[1]]) {
          seen[match[1]] = true;
          handles.push(match[1]);
        }
      }

      if (!handles.length) return [];

      // Her ürünün JSON'ını paralel çek. 'last' sıralaması indeks bozukken
      // güvenilmez; tükenmişler elendikten sonra liste dolsun diye 2 katı çekilir.
      var results = await Promise.all(handles.slice(0, MAX_PRODUCTS * 2).map(_fetchProductJS));
      // Tükenmiş ürün süzgeci BURASI (URL 'last' gönderiyor, eleme yapmıyor).
      // undefined ise dokunmuyor — alan yoksa eleme yapmaz.
      return results
        .filter(function(p) { return p !== null && p.available !== false; })
        .slice(0, MAX_PRODUCTS)
        .map(_cardFromProductJS);
    } catch (e) {
      return [];
    }
  }

  // ─── ÜRÜN KODU FALLBACK ──────────────────────────────────
  /* Shopify arama indeksi tireli SKU'ları tutarsız parçalıyor. The North Face
     SKU'ları "NF0A8JAY2MB1-TNF2MB1-M" biçiminde; müşteri model kodunu
     ("NF0A8JAY2MB1") arıyor. Ölçüm (2026-10-19, stoktaki 50 TNF model kodu):
     tam kodla predictive de /search de yalnızca 9'unu buluyor. Kodun ilk 10
     karakteri ("NF0A8JAY2M") ise 50'sini de buluyor; 11+ karakterde eşleşme
     kopuyor. Aynı kodun büyük/küçük harfli hali de bazen farklı sonuç verdi.
     Bu yüzden: kodu kısaltıp ara, adayları ürün JSON'undaki SKU/barkod içinde
     TAM kodu arayarak süz — kısa önek başka ürünleri getirse de listeye girmez.
     Sadece 1. ve 2. adım boş dönünce çalışır; normal aramalara maliyeti yok. */
  const CODE_RE          = /^(?=.*\d)[A-Za-z0-9._\/-]{7,}$/;  // boşluksuz, en az bir rakam
  const CODE_PREFIX_LENS = [10, 8, 6];

  async function _codeSearch(query) {
    const empty = { products: [], linkQuery: query };
    const q = query.trim();
    if (!CODE_RE.test(q)) return empty;
    const needle = _normCode(q);

    for (const len of CODE_PREFIX_LENS) {
      if (q.length <= len) continue;
      const prefix = q.slice(0, len);
      try {
        const url = `${SEARCH_URL}.json?q=${encodeURIComponent(prefix)}`
          + `&resources[type]=product`
          + `&resources[limit]=${MAX_PRODUCTS}`
          + `&resources[options][fields]=variants.sku,variants.barcode`
          + `&resources[options][prefix]=last`
          + `&resources[options][unavailable_products]=last`;
        const res = await fetch(url, { signal: _abortController.signal });
        if (!res.ok) continue;
        const data = await res.json();
        const handles = (data.resources?.results?.products || []).map(function(p) { return p.handle; });
        if (!handles.length) continue;

        // Predictive yanıtında SKU yok — eşleşmeyi ürün JSON'undan doğrula.
        const found = (await Promise.all(handles.map(_fetchProductJS)))
          .filter(function(p) {
            return p && p.available !== false && (p.variants || []).some(function(v) {
              return _normCode(v.sku).includes(needle) || _normCode(v.barcode) === needle;
            });
          })
          .map(_cardFromProductJS);

        if (found.length) return { products: found, linkQuery: prefix };
      } catch (e) {
        if (e.name === 'AbortError') throw e;
      }
    }
    return empty;
  }

  // "NF0A8JAY2MB1-TNF2MB1-M" ↔ "nf0a8jay2mb1tnf2mb1m": tire/boşluk/harf farkı eşleşmeyi bozmasın
  function _normCode(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function _fetchProductJS(handle) {
    return fetch('/products/' + handle + '.js', { signal: _abortController.signal })
      .then(function(r) { return r.ok ? r.json() : null; })
      .catch(function() { return null; });
  }

  function _cardFromProductJS(p) {
    return {
      id:                  p.id,
      title:               p.title,
      handle:              p.handle,
      vendor:              p.vendor,
      available:           p.available,
      url:                 '/products/' + p.handle,
      price:               (p.price / 100).toFixed(2),
      compare_at_price:    p.compare_at_price ? (p.compare_at_price / 100).toFixed(2) : null,
      compare_at_price_max: p.compare_at_price_max ? (p.compare_at_price_max / 100).toFixed(2) : null,
      featured_image:      { url: p.featured_image }
    };
  }

  // ─── STATE ───────────────────────────────────────────────
  function _showState(state) {
    const els = {
      loading:  _getEl('tc-search-loading'),
      inner:    _getEl('tc-search-results-inner'),
      empty:    _getEl('tc-search-empty'),
      featured: _getEl('tc-search-featured'),
    };
    if (!els.loading) return;
    els.loading.style.display  = state === 'loading'  ? 'flex'  : 'none';
    els.inner.style.display    = state === 'results'  ? 'block' : 'none';
    els.empty.style.display    = state === 'empty'    ? 'flex'  : 'none';
    if (els.featured) els.featured.style.display = state === 'featured' ? 'block' : 'none';
  }

  // ─── CLOSE ───────────────────────────────────────────────
  function close() {
    const panel   = _getEl('tc-search-panel');
    const overlay = _getEl('tc-search-overlay');
    if (panel)   { panel.classList.remove('active');   panel.style.cssText   = 'display:none!important'; }
    if (overlay) { overlay.classList.remove('active'); overlay.style.cssText = 'display:none!important'; }
    document.removeEventListener('keydown', _onEsc);
    if (_abortController) _abortController.abort();
    _currentQuery = '';
    const inp = document.querySelector('#search-template, .search__input[name="q"]');
    if (inp) inp.value = '';
  }

  function clear() { close(); }

  function _injectStyles() {
  if (document.getElementById('tc-search-responsive-css')) return;
  const s = document.createElement('style');
  s.id = 'tc-search-responsive-css';
  s.textContent = `
    /* Panel boşluk/genişlik jetonları.
       --tc-pad clamp'li: 5vw gibi sınırsız birim 2560px'de 128px'e, 3840px'de
       192px'e çıkıp sol panelin 240px'lik kutusunu tamamen yiyordu. */
    #tc-search-panel {
      --tc-pad: clamp(16px, 3.5vw, 56px);
      --tc-pad-inner: 24px;
      --tc-sidebar: 240px;
    }
    /* Değişkenler desteklenmese/ezilse bile sol panel okunmaz hale gelmesin */
    #tc-search-left { min-width: 200px; }

    @media (max-width: 768px) {
      /* Header: alt alta sarsın, arama kutusu tam genişlik */
      #tc-search-panel > div:first-child {
        flex-wrap: wrap !important; gap: 10px !important; padding: 12px 16px !important;
      }
      #tc-search-panel > div:first-child > div:first-child { flex: 1 1 100% !important; }
      /* "Öne Çıkan Markalar" satırını mobilde gizle (yer kazan) */
      #tc-search-panel > div:first-child > div:nth-child(2) { display: none !important; }
      #tc-panel-close-btn { margin-left: auto !important; }

      /* Gövde: yan yana DEĞİL, alt alta + kaydırılabilir */
      #tc-search-panel > div:last-child {
        flex-direction: column !important; overflow-y: auto !important;
        -webkit-overflow-scrolling: touch;
      }

      /* SIRALAMA: mobilde önce ARANAN ÜRÜNLER, kategoriler en altta.
         Kaynak DOM'da sol panel (kategoriler) önce geliyor; flex order ile
         çeviriyoruz — masaüstünde kategoriler yan tarafta kalmaya devam eder. */
      #tc-search-right { order: 1 !important; }
      #tc-search-left  { order: 2 !important; }

      /* Sol panel: sabit genişlik/flex-basis yerine tam genişlik.
         flex:0 0 auto şart — column yönünde flex-basis YÜKSEKLİK olur ve
         calc(240px + ...) paneli bozar. */
      #tc-search-left {
        width: 100% !important; flex: 0 0 auto !important;
        min-width: 0 !important;
        border-right: none !important;
        border-bottom: none !important;
        border-top: 1px solid #f0f0f0 !important;
        padding: 16px !important; overflow: visible !important;
      }
      #tc-search-right { padding: 16px !important; overflow: visible !important; }

      /* ASIL FIX: 5 kolonu 2 kolona indir -> kartlar sıkışmaz, başlık harf harf kırılmaz */
      #tc-search-right [style*="repeat(5"] {
        grid-template-columns: repeat(2, 1fr) !important; gap: 12px !important;
        max-width: none !important;
      }
      /* Kaydırma okları taşmasın */
      #tc-slider-prev { left: 0 !important; }
      #tc-slider-next { right: 0 !important; }
    }
  `;
  document.head.appendChild(s);
}

  // ─── HELPERS ─────────────────────────────────────────────
  function _formatMoney(val) {
    if (!val) return '';
    const num = parseFloat(val);
    if (isNaN(num)) return '';
    return num.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '₺';
  }

  function _escape(str) {
    if (!str) return '';
    return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function _highlight(text, query) {
    if (!query) return _escape(text);
    const escaped = _escape(text);
    const re = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')})`, 'gi');
    return escaped.replace(re, '<mark style="background:#fff3cd;color:inherit;border-radius:2px;padding:0 1px">$1</mark>');
  }

  function _setHeaderHeight() {
    const h = document.querySelector('#header-sticky, .section-header, header');
    if (h) document.documentElement.style.setProperty('--header-height', h.offsetHeight + 'px');
  }

  // ─── HOOK TEMA SEARCH ────────────────────────────────────
  function _hookThemeSearch() {
    init();

    const themeInput = document.querySelector('#search-template, .search__input[name="q"]');
    if (themeInput) {
      themeInput.removeAttribute('style');
      themeInput.removeAttribute('readonly');
      themeInput.addEventListener('click', function(e) {
        e.preventDefault(); e.stopImmediatePropagation(); onFocus();
      }, true);
      themeInput.addEventListener('focus', function(e) {
        this.blur(); onFocus();
      }, true);
    }

    document.querySelectorAll('#search_mini_form').forEach(function(form) {
      form.addEventListener('submit', function(e) { e.preventDefault(); }, true);
    });

    const triggers = document.querySelectorAll(
      '.top-search-toggle, .header_search button, .block-search button'
    );

    if (!triggers.length) {
      document.querySelectorAll('header button:not([type="submit"])').forEach(function(btn) {
        if (btn.querySelector('svg use[href*="search"], svg use[href*="icon-search"]')) {
          btn.addEventListener('click', function(e) {
            e.preventDefault(); e.stopImmediatePropagation(); onFocus();
          }, true);
        }
      });
      if (themeInput) { console.log('[TCSearch] v5.6 hazır, fallback modu.'); return true; }
      return false;
    }

    triggers.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopImmediatePropagation(); onFocus();
      }, true);
    });

    console.log('[TCSearch] v5.6 hazır, ' + triggers.length + ' tetikleyici bağlandı.');
    return true;
  }

  document.addEventListener('DOMContentLoaded', function() {
    _setHeaderHeight();
    window.addEventListener('resize', _setHeaderHeight);
    if (!_hookThemeSearch()) setTimeout(_hookThemeSearch, 600);
  });

  return { onInput, onFocus, close, clear };
})();